function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Preview");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "icon/view"
}, React.createElement("g", {
  id: "secondary-button-copy-3",
  stroke: "#636363"
}, React.createElement("rect", {
  id: "Rectangle-Copy-4",
  x: 0.5,
  y: 0.5,
  width: 46,
  height: 39,
  rx: 4
})), React.createElement("g", {
  id: "View-Copy",
  transform: "translate(12.000000, 13.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M22.8942134,6.54146664 C22.689923,6.27431028 17.8223727,0 11.6056307,0 C5.38888875,0 0.521115146,6.27431028 0.317048115,6.54121046 C0.123566307,6.79466101 0.123566307,7.13841614 0.317048115,7.39186669 C0.521115146,7.65902305 5.38888875,13.9333333 11.6056307,13.9333333 C17.8223727,13.9333333 22.689923,7.65898035 22.8942134,7.39208018 C23.0879631,7.13867232 23.0879631,6.79466101 22.8942134,6.54146664 Z M11.6056307,12.4919614 C7.02633797,12.4919614 3.06018423,8.32757575 1.88611769,6.96617565 C3.05866568,5.60358003 7.01651202,1.44137195 11.6056307,1.44137195 C16.1847002,1.44137195 20.1505859,5.60503173 21.3251438,6.96715768 C20.1525958,8.32971061 16.1947494,12.4919614 11.6056307,12.4919614 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M11.821955,2.53333333 C9.47483337,2.53333333 7.56521739,4.41289523 7.56521739,6.72307717 C7.56521739,9.0332591 9.47483337,10.912821 11.821955,10.912821 C14.1690766,10.912821 16.0786926,9.0332591 16.0786926,6.72307717 C16.0786926,4.41289523 14.1690766,2.53333333 11.821955,2.53333333 Z M11.821955,9.51621214 C10.2571232,9.51621214 8.98415794,8.26323982 8.98415794,6.72307717 C8.98415794,5.18291451 10.2571652,3.92994219 11.821955,3.92994219 C13.3867447,3.92994219 14.659752,5.18291451 14.659752,6.72307717 C14.659752,8.26323982 13.3867868,9.51621214 11.821955,9.51621214 Z",
  id: "Shape"
}))));

const SvgPreviewBorder = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "47px",
    height: "40px",
    viewBox: "0 0 47 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPreviewBorder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/preview-border.d7eb4b9c.svg";
export { ForwardRef as ReactComponent };